import { Component, EventListener, triggerPublicEvent } from '@gondel/core';
import { GondelJqueryComponent } from '@gondel/plugin-jquery';
import addComponentAnimation from '@swisslife/shared-ui/src/utils/animations/js/animations';
import { IGOverlayHandlerOptions } from '@swisslife/shared-types/src/types/gondel-public-events';

enum Selectors {
	Button = '.js-m-links-downloads__trigger-overlay',
}

// The @Component decorator will connect the class with `data-g-name="LinksDownloads"` elements.
@Component('LinksDownloads')
export class LinksDownloads extends GondelJqueryComponent {
	private controllers: any[] = Array();

	public async sync() {
		this.controllers = await addComponentAnimation(this.$ctx);
	}

	public stop() {
		for (const controller of this.controllers) {
			controller.destroy(true);
		}
	}

	@EventListener('click', Selectors.Button)
	private _handleButtonClick(ev: MouseEvent) {
		ev.preventDefault();

		const $target = $(ev.currentTarget!);

		const eventOptions: IGOverlayHandlerOptions = {
			overlayComponent: 'LinksDownloads',
			overlayTitle: $target.data('overlay-title') || '',
			overlayContentUrl: $target.data('overlay-content-url') || '',
		};

		triggerPublicEvent('gOverlayHandler', this, undefined, eventOptions);
	}
}
